/* Initial control values for each component so the playground opens on a
 * good-looking, representative preview. Scalars / enums / booleans / numbers
 * and simple lists are editable in the controls panel; structural props
 * (children, object-lists) get sensible sample content from buildTree. */
export const DEFAULTS: Record<string, Record<string, unknown>> = {
  Row: { alignment: "center" },
  Column: { alignment: "stretch" },
  List: { direction: "vertical" },
  Card: {},
  Tabs: {},
  Modal: {},
  Divider: { axis: "horizontal" },

  Text: { text: "Hello, world", usageHint: "heading" },
  Image: { url: "https://picsum.photos/seed/bex/420/220", altText: "Sample image", fit: "cover" },
  Icon: { name: "star" },
  Video: { url: "" },
  AudioPlayer: { url: "", description: "Sample track" },

  TextField: { label: "Email address", text: "", textFieldType: "shortText" },
  CheckBox: { label: "Subscribe to product updates", value: true },
  DateTimeInput: { value: "", enableDate: true, enableTime: true },
  MultipleChoice: { options: ["Email", "SMS", "Push notification"], selections: [], variant: "chips", filterable: false },
  Slider: { label: "Volume", value: 60, minValue: 0, maxValue: 100 },
  Turnstile: { siteKey: "1x00000000000000000000AA", token: "" },
  Button: { primary: true },
  Form: {},

  DataTable: {
    rows: [
      { name: "Ada Lovelace", role: "Admin", status: "Active" },
      { name: "Linus Torvalds", role: "Member", status: "Invited" },
      { name: "Grace Hopper", role: "Admin", status: "Active" },
    ],
    columns: [
      { key: "name", label: "Name" },
      { key: "role", label: "Role" },
      { key: "status", label: "Status" },
    ],
    pageSize: 5,
    sortable: true,
  },

  Stepper: { steps: [{ label: "Cart" }, { label: "Shipping" }, { label: "Payment" }], currentStep: 1 },
  ProgressIndicator: { value: 64, max: 100, variant: "linear", label: "Uploading…" },
  StatusBadge: { text: "Active", variant: "success" },
  Notification: { text: "Your changes were saved.", variant: "success", dismissible: true },

  Avatar: { initials: "AL", size: "lg" },
  FileUpload: { label: "Attach files", multiple: true },
};
